<template>
  <div
    v-if="downloadInfo"
    class="m-download-app"
  >
    <a
      :href="downloadUrl"
      target="_blank"
      aria-label="Download MSport App"
      @click="handleDownload"
    >
      <img
        :src="downloadInfo.image"
        alt="Download MSport App"
      >
    </a>
    <button
      class="m-close-btn"
      aria-label="Close"
      @click="closeDownloadInfo"
    />
  </div>
</template>

<script>
import parse from 'url-parse'
import useDownloadApp from 'wap/stores/home/useDownloadApp.js'
import { watchOnce } from '@vueuse/core'
import eventBus from '@ms/utils/event-bus'

export default {
  name: 'DownloadApp',
  setup () {
    const { downloadInfo, closeDownloadInfo } = useDownloadApp()
    watchOnce(downloadInfo, (val) => {
      if (val) {
        const img = new Image()
        img.src = val.image
        img.onload = () => { // 监听图片加载完毕后浮球移动
          eventBus.$emit('bubbleBall_move')
        }
      }
    })

    const handleDownload = () => {
      window.mstrace('top_banner_download_android_app')
    }

    return { downloadInfo, closeDownloadInfo, handleDownload }
  },
  computed: {
    downloadUrl () {
      if (!this.downloadInfo) return
      const { from } = parse(location.href, true).query
      if (from) {
        return `${this.downloadInfo.href}?from=${from}`
      }
      return this.downloadInfo.href
    }
  }
}
</script>

<style lang="scss" scoped>
.m-download-app {
  position: relative;
  max-height: 100px;
  background: #333;
  font-size: 14px;

  .m-close-btn {
    position: absolute;
    top: 50%;
    left: 3px;
    display: block;
    width: 30px;
    height: 30px;
    transform: translateY(-50%);
  }

  img {
    display: block;
    width: 100%;
  }
}
</style>
